import { useCallback } from 'react';

import { useHistory } from 'react-router-dom';

import { POPUP_ID_PARAM } from './ComponentPopup';

export const useComponentPopup = () => {
  const history = useHistory();

  const setComponentPopupId = useCallback(
    (componentId: string) => {
      const params = new URLSearchParams(history.location.search);
      params.set(POPUP_ID_PARAM, componentId);

      history.push({ search: params.toString() });
    },
    [history]
  );

  return {
    setComponentPopupId,
  };
};
